import { connect } from 'react-redux';

import { HeaderDeveloper } from './index';
import { IAppState } from '../../../../common/state';

export const HeaderDeveloperContainer = connect((state: IAppState) => ({
  breadcrumbs: state.breadcrumbs,
  developerInfo: state.results.developerInfo,
}))(HeaderDeveloper);
